import {Component, EventEmitter, forwardRef, Input, OnInit, Output, ViewChild} from '@angular/core';
import {
  IntraDevDevelopment,
  IntraDevDevelopmentApi,
  IntraDevHistorique
} from '../../../../../shared/sdk';
import moment from 'moment';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {etatDev, priorite, sectionDev, typeDev} from "../../../models/constDEV";
import {PeopleWithrightsInterface} from '../../../../../core/interfaces/peopleWithrights.interface';
import {ModalCompatibilityService} from '../../../../../core/services/modal-compatibility.service';
import {AppSessionService} from '../../../../../core/services/app.session.service';
import {AppToasterService} from '../../../../../core/services/app.toaster.service';
import {AppGlobalEventManagerService} from '../../../../../core/services/app.globalEventManager.service';
import {FileFormDirective} from '../../../../../core/directives/form/typesFields/file/file.form.directive';
import {FormsDirective} from '../../../../../core/directives/forms/forms.directive';
import {
  DismissModaleDirective
} from '../../../../../core/directives/custom/buttons/dismissModale/dismissModale.directive';
import {NgbActiveModal} from '../../../../../core/components/ngBootstrap/modal/modal-ref';
import { DestroyableComponent } from '../../../../../core/classes/destroyable.component';

@Component({
  selector: 'BugReportModaleDirective',
  imports: [
    forwardRef(() => FormsDirective),
    DismissModaleDirective
  ],
  templateUrl: './bugReport.modale.directive.html'
})
export class BugReportModaleDirective extends DestroyableComponent implements OnInit {
  @Output() clickevent: EventEmitter<any> = new EventEmitter();

  public sections = sectionDev;
  public types = typeDev;
  public etats = etatDev;
  public urgents = priorite;


  public form: FormGroup;

  public user!: PeopleWithrightsInterface;

  development: IntraDevDevelopment = new IntraDevDevelopment();
  histo: IntraDevHistorique = new IntraDevHistorique();

  protected moment = moment;

  addPJ = false;
  public formAddfile: FormGroup;
  @ViewChild('uploadFile', {static: false}) uploadFile: FileFormDirective;

  public folder: string = 'development';

  public columns: any[];



  constructor(
    public _sessionService: AppSessionService,
    public activeModal: NgbActiveModal,
    private _apiService: IntraDevDevelopmentApi,
    private toastr: AppToasterService,
    public formBuilder: FormBuilder,
    private appGlobalEventManagerService: AppGlobalEventManagerService
  ) {
    super();
    this.subscribe(this._sessionService.logguedAccountEmitter, (people) => {
      this.user = people;
    })
    this.formAddfile = this.formBuilder.group({
      file: ['', [Validators.required]]
    });
    this.initForm()
    this.initColumns()
  }

  private initForm() {
    this.form = this.formBuilder.group({
      libelle: ['', [Validators.required]],
      description: ['', [Validators.required]],
      urgent: [1, []],
      type: ['Bug', [Validators.required]],
      etat: ['En étude', [Validators.required]],
      section: ['', [Validators.required]],

      files: ['', []],

    });
  }

  private initColumns() {
    this.columns = [
      {key: "libelle",name: "Libellé", type: "input", required:true},
      {key: "description",name: "Description", type: "text", explain:"Expliquez le problème rencontré, essayez de donner un contexte (si cela se passe dans un DO, donnez la référence ainsi que le nom de l'opération)", required:true},
      {key: "urgent",name: "Urgent ?", type: "select", selectOptions:{multiple:false, labelBind:'text', keyBind:'key', options:priorite}},
      {key: "section",name: "Section", type: "select", selectOptions:{multiple:false, labelBind:'text', keyBind:'key', groupBy:'cat', options:sectionDev}},

      {type:"separator", name:"Fichiers, impressions d'écran", icon:"fa-light fa-files", exclude:true},
      {key: "files",name: "Fichiers", type: "files"},
    ];
  }

  saveObject($values){

    this.appGlobalEventManagerService.openSpinner();

    $values.creator_id = this.user.id;
    $values.datecreation = moment().utc(true);

    if(this.user.id !== 1){
      $values.responsable_id = this.user.id;
    }

    const save$ = this._apiService.create($values);

    this.subscribe(save$, 
      (result: IntraDevDevelopment) => {

        if($values.files && $values.files.length > 0){

          const files = $values.files.map((file) => {
            return {
              file: file.file,
              date: moment().utc(true),
              people_id: this.user.id,
              development_id: result.id
            }
          });

          this.subscribe(this._apiService.createManyFiles(result.id, files), (res) => {
            this.appGlobalEventManagerService.closeSpinner();
            this.toastr.success('Succès !', 'Création du bug');
            this.clickevent.emit(result);
          });

        } else {

          this.appGlobalEventManagerService.closeSpinner();
          this.toastr.success('Succès !', 'Création du bug');
          this.clickevent.emit(result);

        }

      },
      (error) => {
        this.appGlobalEventManagerService.closeSpinner();
        this.toastr.error('Erreur !', 'Création du bug');
        console.error('Erreur lors de la sauvegarde:', error);
      }
    );

  }

  ngOnInit(): void {

  }


}
